<mat-dialog-content class="mat-typography" style="display: contents;">
  <fw-croppie [size]="sizeData"></fw-croppie>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="getImage()" cdkFocusInitial>{{translation.shared.save | transloco}}</button>
  <button mat-button mat-dialog-close>{{translation.shared.close | transloco}}</button>
</mat-dialog-actions>
